import { environment } from "../environments/env";
import Api from "./Api";
import { route } from "./routeDictionary";

export default {
  AddHsm(arr) {
      return Api.post(`${environment.apiUrl}${route.AddHsm}`, arr);
    },
  VerificarHsmLido(destinatario, msg) {
    return Api.get(`${environment.apiUrl}${route.VerificarHsmLido}`, { params: { destinatario: destinatario, msg: msg } });
  },
  BuscarHsmEnviadosPeloUsuario24Horas(remetente) {
      return Api.get(`${environment.apiUrl}${route.BuscarHsmEnviadosPeloUsuario24Horas}`, { params: { remetente: remetente} });
  },
}
